import { CheckCircle, AlertTriangle } from "lucide-react"
import { IntegrationStatus } from "@/models/Integration"

export const StatusIcon = ({ status }: { status: IntegrationStatus }) => {
  return status === "success" ? (
    <CheckCircle width={12} height={12} className="ml-1 text-success-normal" />
  ) : (
    <AlertTriangle width={12} height={12} className="ml-1 text-error-normal" />
  )
}
